import React from 'react';
export const SubSurveyContext = React.createContext(); 